import {useEffect} from 'react';

export const useScrollingHook = (callback) => {
    useEffect(() => {
        window.addEventListener("scroll", callback);
        return () => window.removeEventListener("scroll", callback);
      }, [callback]);
};